<template>
  <div id="berkas">
    <p
      class="text-right px-3"
      v-if="dataPermohonan.status === 0"
    >
      <button
        v-if="this.widgetDokumen.length > 0"
        class="btn btn-primary"
        @click="pilihFile"
      >
        <i class="fa fa-plus mr-2" />Tambah Berkas
      </button>
    </p>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>No</th>
          <th>Jenis Berkas</th>
          <th>Status</th>
          <th style="min-width:190px">
            Tanggal Upload
          </th>
          <th
            v-if="showNamaBerkas"
            colspan="2"
          >
            Nama Berkas
          </th>
          <th>Keterangan</th>
          <th style="min-width:180px">
            Aksi
          </th>
        </tr>
      </thead>
      <tbody v-if="filePermohonan">
        <!-- ini list berkas yang sudah diupload -->
        <tr
          v-for="(b, i) in filePermohonan"
          :key="b.id"
        >
          <td>
            {{ i+1 }}
          </td>
          <td>
            {{ b.dokumen.nama_dokumen }}
          </td>

          <!-- kolom status -->
          <td>
            <ListBerkasBadgeStatus
              :role="role"
              :operator-pembantu="dataPermohonan.id_operator_pembantu"
              :status="dataPermohonan.status"
              :file="b"
            />
          </td>


          <td v-if="b.updated_at">
            {{ new Date(b.updated_at).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) }} {{ new Date(b.updated_at).toLocaleTimeString('it-IT') }}
          </td>
          <td v-else>
            <!-- siapa tau updated at nya gak ada -->
            {{ new Date(b.created_at).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) }} {{ new Date(b.created_at).toLocaleTimeString('it-IT') }}
          </td>

          <td
            v-if="showNamaBerkas"
            style="max-width:30px"
          >
            <img
              :src="require('./../../assets/img/icon/pdf.png')"
              width="20"
              class="mr-2"
            >
          </td>
          <td v-if="showNamaBerkas">
            {{ (b.file) ? b.file.substr(21, 50) : 'Tidak ada File' }}
          </td>
          <td>
            <small v-if="b.keterangan_pemohon != '-' && b.keterangan_pemohon != 'null' && b.keterangan_pemohon">
              <i>Keterangan Pemohon: {{ b.keterangan_pemohon }}</i>
            </small>
            <br>
            <small v-if="b.keterangan_desa != '-' && b.keterangan_desa != 'null' && b.keterangan_desa">
              <i>Keterangan Desa: {{ b.keterangan_desa }}</i>
            </small>
            <br>
            <small v-if="b.keterangan_kecamatan != '-' && b.keterangan_kecamatan != 'null' && b.keterangan_kecamatan">
              <i>Keterangan Kecamatan: {{ b.keterangan_kecamatan }}</i>
            </small>
            <br>
            <small v-if="b.keterangan_dukcapil != '-' && b.keterangan_dukcapil != 'null' && b.keterangan_dukcapil">
              <i>Keterangan Dukcapil: {{ b.keterangan_dukcapil }}</i>
            </small>
          </td>

          <!-- kolom aksi -->
          <td>
            <ListBerkasAksiButton
              :role="role"
              :operator-pembantu="dataPermohonan.id_operator_pembantu"
              :status="dataPermohonan.status"
              :tahap="dataPermohonan.tahap"
              :perlu-valid-desa="dataPermohonan.paket_layanan.is_valid_desa"
              :perlu-valid-kecamatan="dataPermohonan.paket_layanan.is_valid_kecamatan"
              :perlu-valid-dukcapil="dataPermohonan.paket_layanan.is_valid_dukcapil"
              :file="b"
              @handleLihat="lihatFile"
              @handleHapus="hapusFile"
              @handleUploadUlang="uploadUlang"
              @handleRiwayat="riwayatFile"
              @handleValidasi="validFile"
            />
          </td>
        </tr>
      </tbody>
      <tbody v-if="filePermohonan">
        <tr v-if="filePermohonan.length === 0">
          <td colspan="8">
            <p class="text-center">
              Belum ada berkas yang diupload
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal
      id="modal-lihat-file"
      :title="namaBerkasView"
      size="lg"
    >
      <!-- <template #modal-title>
                Upload Berkas
            </template> -->
      <div
        class="embed-responsive"
        style="height: 70vh"
      >
        <!-- <object data="/file/F201.pdf" type="application/pdf" style="width:100%; height:70vh">
                    <embed src="/file/F201.pdf" type="application/pdf" />
                </object> -->
        <iframe
          id="iframepdf"
          :src="linkBerkasView"
          class="embed-responsive-item"
        />
      </div>
            
      <template #modal-footer>
        <button
          type="button"
          value=""
          class="btn btn-primary"
          @click="cetakFile"
        >
          <i class="fa fa-print mr-2" />Cetak
        </button>
      </template>
    </b-modal>


    <b-modal
      id="modal-pilih-file"
      title="Tambah Berkas"
    >
      <!-- <template #modal-title>
                Upload Berkas
            </template> -->

      <div class="form-group">
        <label for="">Jenis Berkas</label>
        <v-select
          id="syarat"
          v-model="form.id_dokumen"
          :options="widgetDokumen"
          :reduce="e => e.id_dokumen"
          label="nama_dokumen"
        />

        <!-- <select class="form-control" v-model="form.id_dokumen">
                    <option v-for="f in widgetDokumen" :key="f.id_layanan_dokumen" :value="f.id_dokumen">{{f.dokumen.nama_dokumen}}</option>
                </select> -->
      </div>

      <div class="form-group">
        <input
          type="file"
          class="form-control"
          @change="selectFile"
          accept="application/pdf"
        >
        <small>File .pdf, maksimal {{ maxFileSize }} MB</small>
        <div
          class="progress mt-3"
          v-if="loading"
        >
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :aria-valuenow="uploadProgress"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{width: uploadProgress+'%'}"
          />
        </div>
      </div>

      <div class="form-group">
        <textarea
          class="form-control"
          placeholder="Keterangan Tambahan"
          v-model="form.keterangan_pemohon"
        />
      </div>
            
            
      <template #modal-footer>
        <button
          id="btnUploadFile"
          type="button"
          class="btn btn-primary"
          @click="submitUploadFile"
        >
          <i class="fa fa-check mr-2" />Upload
        </button>
      </template>
    </b-modal>


    <b-modal
      id="modal-upload-ulang"
      title="Edit Berkas"
    >
      <!-- <template #modal-title>
                Upload Berkas
            </template> -->

      <div class="form-group">
        <label for="">Nama Berkas</label>
        <input
          type="text"
          class="form-control"
          disabled
          v-model="namaBerkasView"
        >
      </div>
            
      <div class="form-group">
        <label for="">Jenis Berkas</label>
        <select
          class="form-control"
          v-model="form.id_dokumen"
          v-if="layananSelected"
          disabled
        >
          <option
            v-for="f in layananSelected.layanan_dokumen"
            :key="f.syarat"
            :value="f.id_dokumen"
          >
            {{ f.dokumen.nama_dokumen }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <input
          type="file"
          class="form-control"
          @change="selectFile"
          accept="application/pdf"
        >
        <small>File .pdf, maksimal {{ maxFileSize }} MB</small>
        <div
          class="progress mt-3"
          v-if="loading"
        >
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :aria-valuenow="uploadProgress"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{width: uploadProgress+'%'}"
          />
        </div>
      </div>

      <div class="form-group">
        <textarea
          class="form-control"
          placeholder="Keterangan Tambahan"
          v-model="form.keterangan_pemohon"
        />
      </div>
            
            
      <template #modal-footer>
        <button
          id="btnUploadUlangFile"
          type="button"
          class="btn btn-primary"
          @click="submitUploadUlangFile"
        >
          <i class="fa fa-check mr-2" />Upload
        </button>
      </template>
    </b-modal>

    <b-modal
      id="modal-lihat-riwayat-file"
      size="lg"
      title="Riwayat File"
    >
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>No</th>
              <th>Status</th>
              <th>Keterangan</th>
              <th
                v-if="showNamaBerkas"
                colspan="2"
              >
                File
              </th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(v, i) in viewRiwayatFile"
              :key="v.id_riwayat_data_permohonan"
            >
              <td>{{ i+1 }}</td>
              <td>
                {{ v.status }}
              </td>
              <td>
                <small v-if="v.keterangan_pemohon"><i>Keterangan pemohon: {{ v.keterangan_pemohon }}</i></small>
                <hr v-if="v.keterangan_desa || v.keterangan_kecamatan || v.keterangan_dukcapil">
                <small v-if="v.keterangan_desa"><i>Keterangan desa: {{ v.keterangan_desa }}</i></small>
                <hr v-if="v.keterangan_kecamatan || v.keterangan_dukcapil">
                <small v-if="v.keterangan_kecamatan"><i>Keterangan kecamatan: {{ v.keterangan_kecamatan }}</i></small>
                <hr v-if="v.keterangan_dukcapil">
                <small v-if="v.keterangan_dukcapil"><i>Keterangan dukcapil: {{ v.keterangan_dukcapil }}</i></small>
              </td>
              <td
                v-if="showNamaBerkas"
                style="max-width:30px"
              >
                <img
                  :src="require('./../../assets/img/icon/pdf.png')"
                  width="20"
                  class="mr-2"
                >
              </td>
              <td v-if="showNamaBerkas">
                {{ (v.file) ? v.file.substr(21, v.file.length - 1) : 'Tidak ada file' }}
              </td>
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  @click="lihatFile(v.b)"
                  v-if="v.file"
                >
                  <i class="fa fa-eye mr-2" />Lihat
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button @click="cancel()">
          Tutup
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<style scoped>
</style>

<script>
import swal from 'sweetalert'
import ListBerkasBadgeStatus from './ListBerkasBadgeStatus.vue'
import ListBerkasAksiButton from './ListBerkasAksiButton.vue'

export default {
  components: {
    ListBerkasBadgeStatus,
    ListBerkasAksiButton
  },
  data() {
    return {
      berkas: null,
      form: {
        id_dokumen: null,
        file: null,
        keterangan_pemohon: ''
      },
      loading: false,
      uploadProgress: 0,
      linkBerkasView: null,
      idFilePermohonanView: null,
      namaBerkasView: null,
      widgetDokumen: [], // di pilih dokumen pas mau upload,
      viewRiwayatFile: [],
      maxFileSize: 2, // dalam mb

      showNamaBerkas: false, // setting mau nampilin nama berkas atau tidak
    }
  },
  computed: {
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    layananSelected() {
      return this.$store.getters.getLayananSelected
    },
    filePermohonan() {
      return this.$store.getters.getFilePermohonan
    },
    role() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  methods: {
    lihatFile(b) {
      this.$store.dispatch('getFile', b.file).then(res => {
          let blob = new Blob([res.data], { type: 'application/pdf' })
          this.linkBerkasView = window.URL.createObjectURL(blob)
      })
      this.namaBerkasView = (this.showNamaBerkas) ? (b.file) ? b.file.substr(21, 50) : 'tidak ada file' : 'File Lampiran Permohonan'
      this.$bvModal.show('modal-lihat-file')
    },
    cetakFile() {
      window.open(this.linkBerkasView)
    },
    pilihFile() {
      this.form.id_dokumen = null,
        this.form.file = null,
        this.form.keterangan_pemohon = ''
      this.$bvModal.show('modal-pilih-file')
    },
    validFile(data) {
      const id = data[0]
      const val = data[1]
      let keterangan = '-'
      if (val === 2) {
        swal("Tambahkan keterangan terkait revisi", {
          title: "Keterangan",
          icon: "warning",
          buttons: {
            cancel: "Batal",
            confirm: "Simpan"
          },
          content: "input",
        })
          .then((res) => {
            if (res) {
              // console.log(res)
              keterangan = res
              this.submitValidasiFile(id, val, keterangan)
            }

          })
      } else {
        this.submitValidasiFile(id, val, keterangan)
      }
    },
    submitValidasiFile(id, val, keterangan) {
      let button = document.querySelector(`.btn-valid-file[data-id="${val}${id}"]`)

      this.loading = true

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'

      let formData = new FormData()


      // cek role nya, kalau desa dispatch kemana, kecamatan kemana
      let dispatchValidasi = 'validasiFilePermohonanByDesa'
      if (this.role === 'Operator Desa' || this.role === 'Kepala Desa') {
        dispatchValidasi = 'validasiFilePermohonanByDesa'
        formData.append('is_valid_desa', val)
        formData.append('keterangan_desa', keterangan)
      } else if (this.role === 'Operator Kecamatan') {
        dispatchValidasi = 'validasiFilePermohonanByKecamatan'
        formData.append('is_valid_kecamatan', val)
        formData.append('keterangan_kecamatan', keterangan)
      } else if (this.role === 'Operator Dukcapil' || this.role === 'Operator Dukcapil Kecamatan') {
        dispatchValidasi = 'validasiFilePermohonanByDukcapil'
        formData.append('is_valid_dukcapil', val)
        formData.append('keterangan_dukcapil', keterangan)
      } else if (this.role === 'Rumah Sakit') {
        dispatchValidasi = 'validasiFilePermohonanByRs'
        formData.append('is_valid_desa', val)
        formData.append('keterangan_desa', keterangan)
      }


      this.$store.dispatch(dispatchValidasi, { id: id, form: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.loadFilePermohonan()
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }

        setTimeout(() => {
          this.loading = false
        }, 1000)
      }).catch(err => {
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }

        setTimeout(() => {
          this.loading = false
        }, 1000)
      })
    },
    submitUploadFile() {

      if (!this.form.file) {
        swal({
          title: "Gagal",
          text: "File kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (!this.form.id_dokumen) {
        swal({
          title: "Gagal",
          text: "Pilih jenis dokumen",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      // validasi file
      const maxFileSize = this.maxFileSize * 1048576 // dalam bytes. 1024 * 1024
      if (this.form.file.size > maxFileSize) {
        swal({
          title: "Gagal",
          text: `Ukuran file lebih dari ${this.maxFileSize} MB`,
          icon: "error",
          buttons: "Ok"
        })
        this.form.file = null
        return false
      }


      let button = document.querySelector('#btnUploadFile')
      let buttonHtml = button.innerHTML
      this.loading = true
      this.uploadProgress = 0

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Upload'

      let formData = new FormData()
      formData.append('file', this.form.file)
      formData.append('keterangan_pemohon', (this.form.keterangan_pemohon) ? this.form.keterangan_pemohon : '-')
      formData.append('id_dokumen', this.form.id_dokumen)
      formData.append('id_data_permohonan', this.dataPermohonan.id_data_permohonan)

      let role = this.$store.getters.getAuthService.currentRole.nama_role
      if (role === 'Operator Desa' || role === 'Kepala Desa' || role === 'Rumah Sakit') {
        formData.append('is_operator_desa', 1)
        formData.append('id_penduduk', this.$store.getters.getPendudukBantu.id_penduduk)
      }

      this.$store.dispatch('uploadBerkasPermohonan', formData).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.loadFilePermohonan()
          this.$bvModal.hide('modal-pilih-file')
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

        this.uploadProgress = 100
        setTimeout(() => {
          this.loading = false
        }, 1000)
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        this.uploadProgress = 100
        setTimeout(() => {
          this.loading = false
        }, 1000)
      })
    },
    selectFile(e) {
      this.form.file = e.target.files[0]
    },
    loadFilePermohonan() {
      this.$store.dispatch('setFilePermohonan', []) // untuk merefresh
      let idDataPermohonan = this.dataPermohonan.id_data_permohonan

      let role = this.$store.getters.getAuthService.currentRole.nama_role
      let dispatch = 'fetchFileDataPermohonan'
      if (role === 'Penduduk') {
        dispatch = 'fetchFileDataPermohonan'
      } else if (role === 'Operator Desa' || role === 'Kepala Desa') {
        dispatch = 'fetchFilePermohonanByDesa'
      } else if (role === 'Operator Kecamatan') {
        dispatch = 'fetchFilePermohonanByKecamatan'
      } else if (role === 'Operator Dukcapil' || role === 'Operator Dukcapil Kecamatan' || role === 'Admin Laksita' || role === 'Admin Jembrana') {
        dispatch = 'fetchFilePermohonanByDukcapil'
      } else if (role === 'Rumah Sakit') {
        dispatch = 'fetchFilePermohonanByRs'
      }

      this.$store.dispatch(dispatch, idDataPermohonan).then(res => {
        if (res.data.status) {
          this.$store.dispatch('setFilePermohonan', res.data.data)
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
      })
    },
    hapusFile(id) {
      let button = document.querySelector(`.btn-hapus-file[data-id="${id}"]`)
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'

      swal({
        title: "Konfirmasi",
        text: "Yakin ingin menghapus file?",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, hapus file",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('hapusBerkasPermohonan', id).then(res => {
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            if (res.data.status) {
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              this.loadFilePermohonan()
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
          }).catch(err => {
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
            // console.log(err)
            switch (err.response.status) {
              case 500:
                this.$router.push({ path: '/500' })
                break;

              case 400:
                swal({
                  title: "Gagal",
                  text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;

              default:
                swal({
                  title: "Gagal",
                  text: err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;
            }
          })
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
        }
      })
    },
    uploadUlang(b) {
      this.namaBerkasView = (b.file) ? b.file.substr(21, 50) : 'Tidak ada file'
      this.idFilePermohonanView = b.id_file_data_permohonan
      this.form.id_dokumen = b.id_dokumen
      this.form.keterangan_pemohon = (b.keterangan_pemohon === 'null' || b.keterangan_pemohon === null) ? '' : b.keterangan_pemohon

      this.$bvModal.show('modal-upload-ulang')
    },
    submitUploadUlangFile() {
      if (!this.form.file) {
        swal({
          title: "Gagal",
          text: "File kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (!this.form.id_dokumen) {
        swal({
          title: "Gagal",
          text: "Pilih jenis dokumen",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      // validasi file
      const maxFileSize = this.maxFileSize * 1048576 // dalam bytes. 1024 * 1024
      if (this.form.file.size > maxFileSize) {
        swal({
          title: "Gagal",
          text: `Ukuran file lebih dari ${this.maxFileSize} MB`,
          icon: "error",
          buttons: "Ok"
        })
        this.form.file = null
        return false
      }

      let button = document.querySelector('#btnUploadUlangFile')
      let buttonHtml = button.innerHTML
      this.loading = true
      this.uploadProgress = 0

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Upload'

      let formData = new FormData()
      formData.append('file', this.form.file)
      formData.append('keterangan_pemohon', this.form.keterangan_pemohon)
      formData.append('id_dokumen', this.form.id_dokumen)

      // jika permohonan ini berstatus revisi,
      // jika dia upload ulang file, ubah is validnya menjadi 3
      // yang artinya revisi sudah diupload

      if (this.role == 'Operator Desa' || this.role == 'Kepala Desa' || this.role === 'Rumah Sakit') {
        formData.append('updateByDesa', 1)
      }

      // revisi desa
      if (this.dataPermohonan.status === 3) {
        formData.append('is_valid_desa', 3)
      } else if (this.dataPermohonan.status === 7) {
        formData.append('is_valid_kecamatan', 7)
      } else if (this.dataPermohonan.status === 11) {
        formData.append('is_valid_dukcapil', 3)
      }

      this.$store.dispatch('updateBerkasPermohonan', { id: this.idFilePermohonanView, data: formData }).then(res => {
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.loadFilePermohonan()
          this.$bvModal.hide('modal-upload-ulang')
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

        this.uploadProgress = 100
        setTimeout(() => {
          this.loading = false
        }, 2000)
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
        this.uploadProgress = 100
        setTimeout(() => {
          this.loading = false
        }, 2000)
      })
    },
    riwayatFile(e, b) {
      let riwayatFile = []
      b.riwayat.forEach(e => {
        riwayatFile.push(e)
        // if(this.role === 'Operator Desa' && e.riwayat_permohonan.status <= 3){
        //     riwayatFile.push(e)
        // } else if(this.role === 'Operator Kecamatan' && e.riwayat_permohonan.status <= 7){
        //     riwayatFile.push(e)
        // } else if(this.role === 'Operator Dukcapil' && e.riwayat_permohonan.status <= 11){
        //     riwayatFile.push(e)
        // }
      })

      this.viewRiwayatFile = []
      riwayatFile.forEach(e => {
        let status = ''
        switch (e.riwayat_permohonan.status) {
          case 0:
            status = 'Permohonan Dibuat'
            break

          // case 1:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 2:
          //     status = 'Permohonan Diajukan'
          //     break

          case 3:
            status = 'Revisi Tingkat Desa'
            break

          // case 4:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 5:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 6:
          //     status = 'Permohonan Diajukan'
          //     break

          case 7:
            status = 'Revisi Tingkat Kecamatan'
            break

          // case 8:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 9:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 10:
          //     status = 'Permohonan Diajukan'
          //     break

          case 11:
            status = 'Revisi Tingkat Dukcapil'
            break

          // case 12:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 13:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 14:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 15:
          //     status = 'Permohonan Diajukan'
          //     break

          // case 16:
          //     status = 'Permohonan Diajukan'
          //     break


        }


        // harusnya semua keterangan!
        // if(this.role === 'Operator Desa' || this.role === 'Kepala Desa'){
        //     keterangan = e.riwayat_permohonan.keterangan_desa
        // } else if(this.role === 'Operator Kecamatan'){
        //     keterangan = e.riwayat_permohonan.keterangan_kecamatan
        // } else if(this.role === 'Operator Dukcapil'){
        //     keterangan = e.riwayat_permohonan.keterangan_dukcapil
        // }

        this.viewRiwayatFile.push({
          id: e.id_riwayat_file_data_permohonan,
          status: status,
          keterangan_pemohon: e.keterangan_pemohon,
          keterangan_desa: e.keterangan_desa,
          keterangan_kecamatan: e.keterangan_kecamatan,
          keterangan_dukcapil: e.keterangan_dukcapil,
          file: e.file,
          b: e
        })
      })
      this.$bvModal.show('modal-lihat-riwayat-file')
    }
  },
  mounted() {
    this.loadFilePermohonan()
    if (!this.layananSelected) {
      let showLayanan = this.dataPermohonan.paket_layanan.layanan

      this.$store.dispatch('selectLayanan', showLayanan)
    }
  },
  watch: {
    dataPermohonan(newVal) {
      this.loadFilePermohonan()
    },
    filePermohonan(newVal) {
      let widget = []
      this.layananSelected.layanan_dokumen.forEach(e => {
        if (newVal.findIndex(f => f.id_dokumen === e.id_dokumen) === -1) {
          let row = e
          // row.nama_dokumen = e.dokumen.nama_dokumen

          // jika isi formulir online, form tidak wajib untuk diupload
          if (this.dataPermohonan.is_form_online === 1) {
            if (e.dokumen.is_form === 1) {
              e.is_harus_diisi = 2 // 2 artinya tidak wajib karena sudah isi form online
            }
          }
          const isWajib = (e.is_harus_diisi === 1) ? ' (wajib)' : ''
          row.nama_dokumen = e.dokumen.nama_dokumen + isWajib

          widget.push(row)
        }
      })
      // console.log(widget)
      this.widgetDokumen = widget
    }
  }
}
</script>